import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { from, Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { AppConfig } from '../../appconfig';
import { AppUrls } from '../app-urls';

@Injectable({providedIn: 'root'})
export class AuthGuardWithForcedLogin  {
  private authService = inject(AuthService);
  private appConfig = inject(AppConfig);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.authService.isDoneLoading$.pipe(
      filter(isDone => isDone),
      switchMap(_ => this.authService.isAuthenticated$),
      tap(isAuthenticated => {

        if (isAuthenticated) {
          return true;
        }
        // when we are not authenticated, we have to check if we should show the login page
        if (this.appConfig.extIdentityShowLogin())
        {
          if(window.location.href !== AppUrls.getBaseUrlAngular() && !window.location.href.endsWith('login')) {

            localStorage.setItem('postLogoutRedirectUrl', window.location.href)
          }
          return from(this.router.navigate(['/login']));
        }
        // if we are not authenticated and the login page should not be shown, we have to login directly
        return this.authService.login(state.url)
      }),
    );
  }
}
